var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTennisPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-448.000000, -473.000000)",
    fill: "#8225FA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(443.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7999667,6.41666667 L18.4083667,6.41666667 C18.4083667,12.4308526 23.3608141,17.3833 29.375,17.3833 L29.375,18.9917 C22.4725193,18.9917 16.7999667,13.3191474 16.7999667,6.41666667 Z M18.4083667,29.8541667 L16.7999667,29.8541667 C16.7999667,23.8399807 11.8475193,18.8875333 5.83333333,18.8875333 L5.83333333,17.2791333 C12.7358141,17.2791333 18.4083667,22.9516859 18.4083667,29.8541667 Z M17.6041667,30.6583667 C10.6591675,30.6583667 5.02913333,25.0283325 5.02913333,18.0833333 C5.02913333,11.1383342 10.6591675,5.5083 17.6041667,5.5083 C24.5491658,5.5083 30.1792,11.1383342 30.1792,18.0833333 C30.1792,25.0283325 24.5491658,30.6583667 17.6041667,30.6583667 Z M17.6041667,29.0499667 C23.660871,29.0499667 28.5708,24.1400377 28.5708,18.0833333 C28.5708,12.026629 23.660871,7.1167 17.6041667,7.1167 C11.5474623,7.1167 6.63753333,12.026629 6.63753333,18.0833333 C6.63753333,24.1400377 11.5474623,29.0499667 17.6041667,29.0499667 Z",
    id: "Oval"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennisPurple);
export default __webpack_public_path__ + "static/media/tennisPurple.0a5ee6328e239cbf8946442fb8504ee9.svg";
export { ForwardRef as ReactComponent };